/* Bogui - masque les variantes epuisees. Lot du 23-10-2026. */
(function(){
function q(o){var v=o.getAttribute("data-quantity");return v===null?null:parseInt(v,10);}
function traite(s){
if(s.getAttribute("data-bg-stock"))return;
var reelles=[],ok=[],ko=[],i,n;
for(i=0;i<s.options.length;i++){if(s.options[i].value!=="")reelles.push(s.options[i]);}
if(reelles.length<2)return;
for(i=0;i<reelles.length;i++){n=q(reelles[i]);if(n===null)return;if(n>0)ok.push(reelles[i]);else ko.push(reelles[i]);}
if(!ok.length)return;
s.setAttribute("data-bg-stock","1");
if(!ko.length)return;
for(i=0;i<ko.length;i++)ko[i].parentNode.removeChild(ko[i]);
if(ok.length===1){var ph=s.querySelector('option[value=""]');if(ph)ph.parentNode.removeChild(ph);s.value=ok[0].value;}
}
function scan(){var l=document.querySelectorAll(".parent_div .selector-wrapper select");for(var i=0;i<l.length;i++)traite(l[i]);}
setTimeout(scan,700);setInterval(scan,2500);
})();
(function(){
if(location.pathname.indexOf("/products/")<0)return;
setTimeout(function(){
fetch(location.pathname.split("?")[0]+".js").then(function(r){return r.json();}).then(function(p){
if(!p.variants||p.variants.length<2)return;
var sels=document.querySelectorAll(".selector-wrapper select"),k,i,j;
for(k=0;k<sels.length;k++){
var s=sels[k];
if(s.closest(".parent_div"))continue;
var di=s.getAttribute("data-index")||"option1";
var idx=parseInt(di.replace("option",""),10)-1;
var ok={};
for(i=0;i<p.variants.length;i++){if(p.variants[i].available)ok[p.variants[i].options[idx]]=1;}
for(j=s.options.length-1;j>=0;j--){var o=s.options[j];if(o.value==="")continue;if(!ok[o.value])o.parentNode.removeChild(o);}
}
}).catch(function(){});
},900);
})();